module.exports = __webpack_public_path__ + "static/media/heavy_pound21.b54a042c.jpg";